import AlertComponent from '@BUP/components/Generics/Alert'
import { FeatureFlagNotificationContext } from '@BUP/contexts/FeatureFlagNotificationContext'
import { Skeleton } from 'antd'
import { useContext } from 'react'

const AlertInfoNotification = () => {
  const { isLoadingFeatureFlagNotification, featureFlagNotification, errorFeatureFlagNotification } = useContext(FeatureFlagNotificationContext)

  if (!featureFlagNotification || errorFeatureFlagNotification) return null

  if (featureFlagNotification.enabled) {
    return (
      <Skeleton loading={isLoadingFeatureFlagNotification}>
        <AlertComponent type='info' message='Recuerda ir registrando toda la información que pueda aportar en el progreso de la investigación y de la denuncia en general. En BRAVE UP! queremos apoyarte en este proceso y para ello cada cierto tiempo te enviaremos correos para recordarte la etapa en la que te encuentras y la información que debes adjuntar.' />
      </Skeleton>
    )
  }

  return null
}

export default AlertInfoNotification
